import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

/**
 * Audit API
 * Handles fetching administrative audit logs.
 */
const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "audit-logs",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 600000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const restore = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `audit-logs/restore/${args?.id}`,
      method: "post",
      authorization: true,
      config: {
        successMsg: "Item restored successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  list,
  restore,
};
